export const genresTranslation = {
  'ANTIQUES & COLLECTIBLES': 'ANTIGUIDADES E COLECIONÁVEIS',
  ARCHITECTURE: 'ARQUITETURA',
  ART: 'ARTE',
  BIBLES: 'BÍBLIAS',
  'BIOGRAPHY & AUTOBIOGRAPHY': 'BIOGRAFIA E AUTOBIOGRAFIA',
  'BODY, MIND & SPIRIT': 'CORPO, MENTE E ESPÍRITO',
  'BUSINESS & ECONOMICS': 'ECONOMIA DE NEGÓCIOS',
  'COMICS & GRAPHIC NOVELS': 'QUADRINHOS E ROMANCES GRÁFICAS',
  COMPUTERS: 'COMPUTADORES',
  COOKING: 'COZINHANDO',
  'CRAFTS & HOBBIES': 'ARTESANATOS E HOBBIES',
  DESIGN: 'PROJETO',
  DRAMA: 'DRAMA',
  EDUCATION: 'EDUCAÇÃO',
  'FAMILY & RELATIONSHIPS': 'RELAÇÕES FAMILIARES',
  FICTION: 'FICÇÃO',
  'FOREIGN LANGUAGE STUDY': 'ESTUDO DE LÍNGUA ESTRANGEIRA',
  'GAMES & ACTIVITIES': 'JOGOS E ATIVIDADES',
  GARDENING: 'JARDINAGEM',
  'HEALTH & FITNESS': 'SAÚDE',
  HISTORY: 'HISTÓRIA',
  'HOUSE & HOME': 'CASA LAR',
  HUMOR: 'HUMOR',
  'JUVENILE FICTION': 'FICÇÃO JUVENIL',
  'JUVENILE NONFICTION': 'NÃO FICÇÃO JUVENIL',
  'LANGUAGE ARTS & DISCIPLINES': 'ARTES E DISCIPLINAS DA LINGUAGEM',
  LAW: 'LEI',
  'LITERARY COLLECTIONS': 'COLEÇÕES LITERÁRIAS',
  'LITERARY CRITICISM': 'CRÍTICA LITERÁRIA',
  MATHEMATICS: 'MATEMÁTICA',
  MEDICAL: 'MÉDICO',
  MUSIC: 'MÚSICA',
  NATURE: 'NATUREZA',
  'PERFORMING ARTS': 'ARTES PERFORMÁTICAS',
  PETS: 'ANIMAIS DE ESTIMAÇÃO',
  PHILOSOPHY: 'FILOSOFIA',
  PHOTOGRAPHY: 'FOTOGRAFIA',
  POETRY: 'POESIA',
  'POLITICAL SCIENCE': 'CIÊNCIA POLÍTICA',
  PSYCHOLOGY: 'PSICOLOGIA',
  REFERENCE: 'REFERÊNCIA',
  RELIGION: 'RELIGIÃO',
  SCIENCE: 'CIÊNCIA',
  'SELF - HELP': 'AUTO - AJUDA',
  'SOCIAL SCIENCE': 'CIÊNCIAS SOCIAIS',
  'SPORTS & RECREATION': 'ESPORTES E RECREAÇÃO',
  'STUDY AIDS': 'AJUDA PARA ESTUDO',
  'TECHNOLOGY & ENGINEERING': 'TECNOLOGIA E ENGENHARIA',
  TRANSPORTATION: 'TRANSPORTE',
  TRAVEL: 'VIAGEM',
  'TRUE CRIME': 'CRIME VERDADEIRO',
  'YOUNG ADULT FICTION': 'FICÇÃO PARA JOVENS ADULTOS',
  'YOUNG ADULT NONFICTION': 'NÃO FICÇÃO PARA JOVENS ADULTOS',
  'ROMANCE': 'ROMANCE'
}